import React from "react";

export default function Step2({ data, setData }) {
  return (
    <div className="rules">
      <h3>Húsreglur Hugarafls</h3>
      <ol>
        <li>Húsið er opið alla virka daga. Opnunartímar eru auglýstir sérstaklega.  </li>
        <li>Hljóð- og myndbandsupptökur eru með öllu óheimilar í húsnæði Hugarafls nema með sérstöku leyfi.</li>
        <li>Ofbeldi af öllu tagi leiðir tafarlaust til brottrekstrar úr félaginu. </li>
        <li>Við lítum á staðinn sem vinnuumhverfi okkar allra þar sem við berum sameiginlega ábyrgð á umgengni og hegðun. </li>
        <li>Við göngum vel um húsið og við göngum alltaf frá eftir okkur. </li>
        <li>Í samskiptum er lögð áhersla á trúnað, virðingu og nærgætni. </li>
        <li>Munum þagnarskylduna, hún er grundvöllur alls starfs í húsinu.</li>
        <li>Gæludýrahald er með öllu óheimilt í húsinu.</li>
        <li>Við förum úr skóm og blautum yfirhöfnum í anddyri áður en við höldum inn í húsið. </li>
        <li>Pössum verðmæti okkar, þau eru á okkar eigin ábyrgð. Passið að skilja engin verðmæti eftir á glámbekk.</li>
        <li>Persónuleg og/eða viðkvæm málefni, hvort sem þau snúa að einstaklingum eða samfélagsumræðu, eru ekki rædd í alrými. Verum ábyrg í tali í húsinu. Athugið að það er ekki rætt um persónuleg mál einstaklinga sem eru ekki á svæðinu. </li>
        <li>Hópar geta notað húsið utan opnunartíma skv. samkomulagi. Þá bera hópstjórar ábyrgð á að loka og læsa og að húsreglur séu virtar. </li>
        <li>Það er ekki leyfilegt að neyta áfengis eða ólöglegra vímuefna á staðnum og/eða vera undir áhrifum þeirra. </li>
        <li>Vinnurými hússins (salir, tónlistarh., jóga o.fl.) má nýta sem afdrep stöku sinnum, sé þess þörf, í hámark eina klukkustund í senn. Vilji einstaklingur nýta rýmið til lengri tíma þarf að biðja um leyfi. </li>
      </ol>
      <label className="checkbox">
        <input
          type="checkbox"
          checked={data.has_completed_orientation}
          onChange={(e)=>setData(d=>({...d,has_completed_orientation:e.target.checked}))}
        />
        Ég hef lokið nýliðakynningu
      </label>
      <label className="checkbox">
        <input
          type="checkbox"
          checked={data.accepts_house_rules}
          onChange={(e)=>setData(d=>({...d,accepts_house_rules:e.target.checked}))}
        />
        Ég samþykki að fara eftir húsreglum Hugarafls*
      </label>
    </div>
  );
}